import type { SessionModel } from '@generated-types';
import { createContext } from 'react';

interface GuaranteedSessionContextType {
    session: SessionModel | null;
}

const initialGuaranteedSessionContext = {
    session: null,
};

export const GuaranteedSessionContext = createContext<GuaranteedSessionContextType>(initialGuaranteedSessionContext);
